<h2 class="papel-title">Fotografía la guía firmada</h2>

<button
  *ngIf="!photoBase64 && !papelCameraActive"
  type="button"
  class="papel-camera-trigger"
  (click)="startPapelCamera()"
  aria-label="Abrir cámara">
  <i class="bi bi-camera papel-camera-icon"></i>
</button>

<div class="papel-gallery-section">
  <div *ngIf="!photoBase64 && !papelCameraActive" class="papel-capture-row">
    <button type="button" class="papel-choose-btn" (click)="startPapelCamera()" aria-label="Abrir cámara">
      <i class="bi bi-camera"></i>
      Tomar foto
    </button>
  </div>

  <div *ngIf="papelCameraActive && !photoBase64" class="papel-camera-view">
    <video #papelVideo autoplay playsinline muted class="papel-camera-view__video"></video>
    <canvas #papelCanvas hidden></canvas>
    <div class="papel-camera-actions">
      <button type="button" class="btn btn-guardar" (click)="capturePapelPhoto()">Capturar</button>
      <button type="button" class="papel-retry-btn" (click)="cancelPapelCamera()">Cancelar</button>
    </div>
  </div>

  <div *ngIf="photoBase64" class="papel-preview">
    <img [src]="photoBase64" alt="Vista previa de la guía firmada" class="papel-preview__image" />
    <button type="button" class="papel-retry-btn" (click)="retryPapelPhoto()">Tomar otra foto</button>
  </div>
</div>
